import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

export async function logout({ http: { post } }: UtilityContext): Promise<void> {
	return post('/api-proxy/-/users/logout');
}
